import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { SignalHttpService } from '../../../../core/signal';
import { Cache } from 'aws-amplify';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'kt-signal-strength',
  templateUrl: './signal-strength.component.html',
  styleUrls: ['./signal-strength.component.scss']
})
export class SignalStrengthComponent implements OnInit {

	@ViewChild(BaseChartDirective, {static: false}) chart: BaseChartDirective;

	closeResult: string;

	public lineChartData: Array<any> = [];
	public lineChartLabels: Array<any> = [];

	public lineChartOptions: any = {
		responsive: true,
		legend: {
			labels: {
			fontColor: 'black'
			}
		},
		scales: {
			yAxes: [{
			ticks: {
				fontColor: 'black',
				// Include a dollar sign in the ticks
				callback: function(value, index, values) {
					return value + 'dBm';
				}
			}
		}],
		xAxes: [{
			ticks: {
				fontColor: 'black'
			}
	  }]
	  }
  };
  public lineChartLegend = true;
  public lineChartType = 'line';

  chartData;

  selectedMachine = Cache.getItem('selected_machine');

  constructor(private http: SignalHttpService, private cdr: ChangeDetectorRef, private modalService: NgbModal) { }

  ngOnInit() {
	  this.getSignalStrength();
  }

  getSignalStrength() {
	this.http.getSignalStrength(this.selectedMachine.m_id)
	.subscribe((values: any[]) => {
		console.log(values);
		values = values.reverse();
		const chartData = {
			yData: [],
			xData: [],
			yColor: []
		};
		for (const tArr of values) {
			chartData.yData.push(((+tArr.rssi) * -1).toFixed(1));
			chartData.yColor.push(this.rssiColor(((+tArr.rssi) * -1)));
			chartData.xData.push( new Date(tArr.date_utc).toLocaleDateString() + ' ' + new Date(tArr.date_utc).toLocaleTimeString());
		}
		this.chartData = chartData;
		this.lineChartLabels = chartData.xData;
		console.log(chartData);
		this.lineChartData.push({data: chartData.yData, borderColor: '#d9d9d9',
		pointBackgroundColor: chartData.yColor, pointBorderColor: chartData.yColor, label: 'RSRP', fill: false});
		this.cdr.detectChanges();
	}, error => {
		console.log(error);
	});
  }

  rssiColor(rssi) {
	if (rssi >= -80 ){
		return 'rgb(51, 204, 51)';
	} else if (rssi >= -90 && rssi <= -80) {
		return '#dfb510';
	} else if (rssi >= -100 && rssi <= -90) {
		return 'rgb(255, 102, 0)';
	} else if (rssi <= -100) {
		return 'rgb(204, 0, 0)';
	}
  }

  open(content) {
	this.modalService.open(content, {size: 'lg'}).result.then((result) => {
	this.closeResult = `Closed with: ${result}`;
	}, (reason) => {
		this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
	});
}

private getDismissReason(reason: any): string {
	if (reason === ModalDismissReasons.ESC) {
		return 'by pressing ESC';
	} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
		return 'by clicking on a backdrop';
	} else {
		return  `with: ${reason}`;
	}
}



}
